{
  "record": "Student",
  "index": {
    "add": "Add Student",
    "manage_student": "Manage Student",
    "title": "Students",
    "view_student_preferences": "View Student Preferences",
    "empty_list_title": "No Students",
    "empty_list_description": "Click the add student button to add a student to SageCool.",
    "edit_preferences": "Edit Preferences",
    "view_classes": "View Classes"
  },
  "new": {
    "title": "Create Student"
  }
}
